/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAbridgedCyberBenchmark
 */
export interface ControlAbridgedCyberBenchmark {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlAbridgedCyberBenchmark
     */
    overall?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ControlAbridgedCyberBenchmark interface.
 */
export function instanceOfControlAbridgedCyberBenchmark(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlAbridgedCyberBenchmarkFromJSON(json: any): ControlAbridgedCyberBenchmark {
    return ControlAbridgedCyberBenchmarkFromJSONTyped(json, false);
}

export function ControlAbridgedCyberBenchmarkFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAbridgedCyberBenchmark {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'overall': !exists(json, 'overall') ? undefined : json['overall'],
    };
}

export function ControlAbridgedCyberBenchmarkToJSON(value?: ControlAbridgedCyberBenchmark | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'overall': value.overall,
    };
}

